import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

const REVENUE_ROLES = new Set(["SUPER_ADMIN", "ACCOUNTS"]);

/** Wrap admin/revenue routes so only SUPER_ADMIN + ACCOUNTS get in. */
export default function RevenueGuard({ children }) {
    const { user, status } = useAuth();
    const location = useLocation();
    if (status === "checking") return null;
    if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
    if (!REVENUE_ROLES.has(user.role)) {
        setTimeout(() => toast.error("You don't have access to Revenue tools."), 0);
        return <Navigate to="/dashboard" replace />;
    }
    return children;
}
